//types
import { DocumentTypeEnum } from 'app/models';

export type CertificateType = (typeof certificateTypes)[number];

//constants
export const documentTypes = ['passport', 'driverLicence', 'bankAccount'] as const;
export const certificateTypes = ['BANK', 'OGRN', 'INN', 'OTHER'] as const;

export const certificateLocalizedNameMap: Record<CertificateType, string> = {
	OTHER: 'profile-other',
	BANK: 'profile-bank',
	OGRN: 'profile-ogrn',
	INN: 'profile-inn',
};

export const documentTypeMap: Record<string, DocumentTypeEnum | undefined> = {
	'passport-mainPage': DocumentTypeEnum.PassportMainPage,
	'passport-registrationPage': DocumentTypeEnum.PassportRegPage,
	'driverLicence-mainPage': DocumentTypeEnum.DriverMainPage,
	'driverLicence-backPage': DocumentTypeEnum.DriverBackPage,
};

export const documentLocalizedLabelMap: Record<string, string> = {
	'passport-mainPage': 'profile-label-passport-main-page',
	'passport-registrationPage': 'profile-label-passport-registration-page',
	'driverLicence-mainPage': 'profile-label-licence-front-page',
	'driverLicence-backPage': 'profile-label-licence-back-page',
};
